import { useMutation, useQuery } from "react-query";
import { ManualEmissionItem } from "../../../api";
import { useAuth } from "../../../context";

export const manualEmissionItemKeys = {
  all: () => ["manualEmissionItems"],
  byScope: (questionnaireId, scopeCategoryKey) =>
    [...manualEmissionItemKeys.all(), questionnaireId, scopeCategoryKey]
};

export function useGetManualEmissionItems({ questionnaireId, scopeCategoryKey }, config) {
  const { callApi } = useAuth();
  return useQuery(
    manualEmissionItemKeys.byScope(questionnaireId, scopeCategoryKey),
    () => callApi(ManualEmissionItem.getItems, { questionnaireId, scopeCategoryKey }),
    { enabled: !!questionnaireId && !!scopeCategoryKey, ...config }
  );
}

export function useCreateManualEmissionItems(config) {
  const { callApi } = useAuth();
  return useMutation(
    ({ questionnaireId, data }) => callApi(ManualEmissionItem.createItems, { questionnaireId, data }),
    config
  );
}

export function useUpdateManualEmissionItem(config) {
  const { callApi } = useAuth();
  return useMutation(
    ({ questionnaireId, id, data }) => callApi(ManualEmissionItem.updateItem, { questionnaireId, id, data }),
    config
  );
}

export function useDeleteManualEmissionItem(config) {
  const { callApi } = useAuth();
  return useMutation(
    ({ questionnaireId, id }) => callApi(ManualEmissionItem.deleteItem, { questionnaireId, id }),
    config
  );
}
